﻿export class BulkActionTarget {
    constructor(public workItemId: string, public workItemVersionId: string) {}
}